
export enum CustomerStatusCd {
	ACTIVE = 'Active',
	EXPIRED = 'Expired',
	INACTIVE = 'Inactive'}

